export default __webpack_public_path__ + "static/media/aircond3.d7c492b2.png";